<header>
  <nav class="navbar navbar-expand-lg mb-0 navbar-light" role="navigation">
    <div>
      <div class="navbar-header tasc-navbar-header ml-5">
        <a tabindex="0" role="button" (keyup.enter)="$event.target.click()" routerLink="/plan/plans" id="tascHome">
          <img [alt]="brand.companyName" src="assets/img/{{ brand.logoFileName }}" title="Home" />
        </a>
      </div>
    </div>
    @if (customizationLogo?.isCustomBranding) {
      <div class="vertical-separator"></div>
    }
    @if (customizationLogo?.isCustomBranding) {
      <div class="cobranding">
        <div class="cobranding-logo-wrapper">
          <img alt="cobrand-logo" src="{{ customizationLogo.url }}" title="Cobranding" />
        </div>
      </div>
    }
    <div class="ml-auto">
      <div class="row mr-0 pr-0">
        <div class="col-12">
          <div class="navbar-collapse collapse quick-link">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a class="nav-link p-4">
                  <span (click)="toggleAlerts()" tabindex="0" role="button" (keyup.enter)="$event.target.click()">
                    @if (unreadCount > 0) {
                      <span class="unreadCount">{{ unreadCount }}</span>
                    }
                    <img src="../../../../assets/img/Green.svg" class="alert-icon" alt="" />Alerts
                  </span>
                </a>
              </li>
              <li class="nav-item">
                <a
                  data-cy="settings-nav-item"
                  class="nav-link p-4"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="$event.target.click()"
                  (mouseenter)="$event.target.click()"
                  (mouseleave)="onOpenDropdown()"
                  (click)="onOpenDropdown(HeaderDropdowns.Settings)"
                  id="settingLink"
                  routerLinkActive="active"
                  >Settings
                  <ul data-cy="settings-list-items" class="menu-list" [ngClass]="{ 'nav-menu-keyboard-hover': openDropdown === HeaderDropdowns.Settings }">
                    <li data-cy="settings-profile" *appHasPermission="'/settings/profile'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Settings)" routerLink="/settings/profile">
                      <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="profileLink" class="pr-5">Profile</a>
                    </li>
                    @if (client && contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions)) {
                      <li *appHasPermission="'/settings/manage-users'" tabindex="0" role="button" data-cy="manage-users-link" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Settings)" routerLink="/settings/manage-users">
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="manage-users" class="pr-5">Manage users</a>
                      </li>
                    }
                    @if (client && contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions)) {
                      <li
                        *appHasPermission="'/settings/manage-distributor-access'"
                        tabindex="0"
                        role="button"
                        data-cy="distributor-access-link"
                        (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Settings)"
                        routerLink="/settings/manage-distributor-access"
                      >
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="manage-distributor-access" class="pr-5">Manage distributor access</a>
                      </li>
                    }
                    @if (hasBenefitPlan$ | async) {
                      <li *appHasPermission="'/settings/payroll-schedule'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Settings)" routerLink="/settings/payroll-schedule">
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="payroll-schedule" class="pr-5">Payroll schedule </a>
                      </li>
                    }
                    @if (isClasses) {
                      <li data-cy="settings-classes" *appHasPermission="'/settings/classes'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Settings)" routerLink="/settings/classes">
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="classes" class="pr-5">Classes</a>
                      </li>
                    }
                    @if (divisions$ | async; as divisions) {
                      @if (divisions.length > 0) {
                        <li data-cy="settings-divisions" *appHasPermission="'/settings/divisions'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Settings)" routerLink="/settings/divisions">
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="divisions" class="pr-5">Divisions</a>
                        </li>
                      }
                    }
                    @if (client && contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions)) {
                      <li *appHasPermission="'/settings/bank-accounts'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Settings)" routerLink="/settings/bank-accounts">
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="bank-accounts" class="pr-5">Bank accounts</a>
                      </li>
                    }
                    <li *appHasPermission="'/settings/signin-security'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Settings)" routerLink="/settings/signin-security">
                      <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="signin-security" class="pr-5">Sign in & security </a>
                    </li>
                    <li class="d-none">
                      <a>User Access</a>
                    </li>
                  </ul>
                </a>
              </li>
              <li class="nav-item">
                <a
                  class="nav-link p-4"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="$event.target.click()"
                  (mouseenter)="$event.target.click()"
                  (mouseleave)="onOpenDropdown()"
                  (click)="onOpenDropdown(HeaderDropdowns.Support)"
                  id="supportLink"
                  data-cy="support-link"
                  routerLinkActive="active"
                  >Support
                  <ul class="menu-list" data-cy="support-hover" [ngClass]="{ 'nav-menu-keyboard-hover': openDropdown === HeaderDropdowns.Support }">
                    <li *appHasPermission="'/support/support-requests'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Support)" routerLink="/support/support-requests">
                      <a #supportRequests id="supportRequestsLink" class="pr-5" (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button">Support Requests</a>
                    </li>
                    <li *appHasPermission="'/support/support-user-guides-and-videos'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Support)" routerLink="/support/support-user-guides-and-videos">
                      <a id="supportUserGuidesAndVideos" data-cy="user-guides-link" class="pr-5" (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button">Help Content </a>
                    </li>
                    <li *appHasPermission="'/support/add-support'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Support)" routerLink="/support/add-support">
                      <a id="supportContactUs" data-cy="contact-us-link" class="pr-5" (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button">Contact Us </a>
                    </li>
                  </ul>
                </a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link p-4" tabindex="0" role="button" aria-label="Toggle Dropdown" (keyup.enter)="$event.target.click()" (mouseenter)="onOpenDropdown()" (mouseleave)="onOpenDropdown()" (click)="onOpenDropdown()">
                  {{ userName }}
                  <i class="icon-dropdown" aria-hidden="true"></i>
                  <span class="sr-only">Toggle Dropdown</span>
                </a>
                <ul class="dropdown-menu">
                  <li class="dropdown-item">
                    <a routerLink="/logout">Sign out</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row mr-0 pr-0">
        <div class="col-12">
          <div class="navbar-collapse collapse main-menu pr-2">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item" *appHasPermission="'menuOverview'">
                <a
                  class="nav-link py-4"
                  tabindex="0"
                  role="button"
                  (mouseenter)="onOpenDropdown()"
                  (mouseleave)="onOpenDropdown()"
                  (keyup.enter)="$event.target.click()"
                  (click)="onOpenDropdown()"
                  routerLinkActive="active"
                  routerLink="/home"
                  id="menuOverview"
                  >Overview</a
                >
              </li>
              <li class="nav-item" *appHasPermission="'menuEmployee'" data-cy="employee-menu">
                <a
                  class="nav-link py-4"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="$event.target.click()"
                  (mouseenter)="$event.target.click()"
                  (mouseleave)="onOpenDropdown()"
                  (click)="onOpenDropdown(HeaderDropdowns.Employees)"
                  routerLinkActive="active"
                  id="menuEmployees"
                  >Employees
                  <ul class="menu-list" data-cy="employee-menu-list" [ngClass]="{ 'nav-menu-keyboard-hover': openDropdown === HeaderDropdowns.Employees }">
                    @if (client && contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions || showAddAndEnrollEmployee())) {
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Employees)" routerLink="/employees/manage/add" *appHasPermission="'/employees/manage/add'">
                        <a id="add-employees" (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button">Add employees</a>
                      </li>
                    }
                    <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Employees)" *appHasPermission="'/employees/manage'" routerLink="/employees/manage">
                      <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="manageEmp">View employees</a>
                    </li>
                    @if (hasBenefitPlan$ | async) {
                      @if (client && contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions || showAddAndEnrollEmployee())) {
                        <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Employees)" routerLink="/employees/enroll" *appHasPermission="'/employees/enroll'">
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="enrollEmp">Enroll employees</a>
                        </li>
                      }
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Employees)" routerLink="/employees/approve" *appHasPermission="'/employees/approve'">
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="approveEnrollment">Approve enrollment</a>
                      </li>
                    }
                    @if (hasPaymentPlan$ | async) {
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Employees)" *appHasPermission="'/employees/view-events'" routerLink="/employees/view-events">
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="empEvents">View Events</a>
                      </li>
                    }
                    @if (displayVaccineReport | async; as displayVax) {
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Employees)" routerLink="/employees/vaccine" *appHasPermission="'/employees/vaccine'">
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="vaccineTracking">Vaccine Tracking</a>
                      </li>
                    }
                    <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Employees)" *appHasPermission="'/employees/enroll-employee'" class="d-none" routerLink="/employees/enroll-employee">
                      <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="approveEnrollment">Enroll Grid</a>
                    </li>
                  </ul>
                </a>
              </li>
              <li class="nav-item" *appHasPermission="'menuPlans'">
                <a
                  class="nav-link py-4"
                  tabindex="0"
                  role="button"
                  data-cy="home-nav-plans"
                  (keyup.enter)="$event.target.click()"
                  (mouseenter)="$event.target.click()"
                  (mouseleave)="onOpenDropdown()"
                  (click)="onOpenDropdown(HeaderDropdowns.Offerings)"
                  routerLinkActive="active"
                  id="benefitPlans"
                  >Offerings
                  <ul class="menu-list" data-cy="plans-menu-list" [ngClass]="{ 'nav-menu-keyboard-hover': openDropdown === HeaderDropdowns.Offerings }">
                    <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Offerings)" routerLink="/plan/plans" *appHasPermission="'/plan/plans'">
                      <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="view-plans" data-cy="sub-nav-view-plans">View plans</a>
                    </li>
                    @if (client && contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions)) {
                      @if ({ hasClientAccounts: hasClientAccounts$ | async }; as data) {
                        <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Offerings)" *appHasPermission="'/plan/client-accounts'">
                          @if (data.hasClientAccounts) {
                            <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" routerLink="/plan/client-accounts" id="manage-employer-accounts" data-cy="sub-nav-manage-employer-accounts"
                              >Manage employer accounts</a
                            >
                          }
                          @if (!data.hasClientAccounts) {
                            <a title="No employer accounts found" id="manage-employer-accounts-disabled" class="link-disabled" data-cy="sub-nav-manage-employer-accounts-disabled">Manage employer accounts</a>
                          }
                        </li>
                      }
                    }
                    @if (hasBenefitPlan$ | async) {
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Offerings)" routerLink="/plan/verify" *appHasPermission="'/plan/verify'">
                        <a (click)="openDropdown = null" (keyup.enter)="$event.target.click()" tabindex="0" role="button" id="verify-posting-menu">Verify posting (PVR)</a>
                      </li>
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Offerings)" routerLink="/plan/summary" *appHasPermission="'/plan/summary'">
                        <a (click)="openDropdown = null" (keyup.enter)="$event.target.click()" tabindex="0" role="button" id="posting-summary-menu">Posting summary</a>
                      </li>
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Offerings)" routerLink="/plan/post-manually" *appHasPermission="'/plan/post-manually'">
                        <a (click)="openDropdown = null" (keyup.enter)="$event.target.click()" tabindex="0" role="button" id="post-manually-menu">Post manually</a>
                      </li>
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Offerings)" routerLink="/plan/terminate" *appHasPermission="'/plan/terminate'">
                        <a (click)="openDropdown = null" (keyup.enter)="$event.target.click()" tabindex="0" role="button" id="remove-employee-menu">Remove employees</a>
                      </li>
                    }
                  </ul>
                </a>
              </li>

              @if (client && contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions)) {
                <li *appHasPermission="'menuFunding'" class="nav-item">
                  <a
                    (keyup.enter)="$event.target.click()"
                    (mouseenter)="$event.target.click()"
                    (mouseleave)="onOpenDropdown()"
                    (click)="onOpenDropdown(HeaderDropdowns.Transactions)"
                    class="nav-link py-4"
                    tabindex="0"
                    role="button"
                    data-cy="funding-menu"
                    routerLinkActive="active"
                    id="menuFunding"
                    >Transactions
                    <ul class="menu-list" data-cy="transactions-menu-list" [ngClass]="{ 'nav-menu-keyboard-hover': openDropdown === HeaderDropdowns.Transactions }">
                      @if (hasBenefitPlan$ | async) {
                        <li
                          tabindex="0"
                          role="button"
                          (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Transactions)"
                          routerLink="/transactions/funding"
                          *appHasPermission="'/transactions/funding'"
                          data-cy="funding-transaction-menu"
                        >
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="funding-transactions-menu">View Transactions</a>
                        </li>
                        <li
                          tabindex="0"
                          role="button"
                          (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Transactions)"
                          routerLink="/transactions/fund-from-cash-account"
                          *appHasPermission="'/transactions/fund-from-cash-account'"
                          data-cy="fund-from-cash-account-menu"
                        >
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="fund-from-cash-account-menu">Fund From Cash Account</a>
                        </li>
                      }
                      @if (hasPaymentPlan$ | async) {
                        <li
                          tabindex="0"
                          role="button"
                          (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Transactions)"
                          routerLink="/transactions/remittance-account"
                          *appHasPermission="'/transactions/remittance-account'"
                          data-cy="remittance-account-menu"
                        >
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="remittance-account-menu">Remittance</a>
                        </li>
                      }
                    </ul>
                  </a>
                </li>
              }
              <li class="nav-item" *appHasPermission="'menuFiles'">
                <a
                  class="nav-link py-4"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="$event.target.click()"
                  (mouseenter)="$event.target.click()"
                  (mouseleave)="onOpenDropdown()"
                  (click)="onOpenDropdown(HeaderDropdowns.Files)"
                  routerLinkActive="active"
                  id="menuFiles"
                  >Files
                  <ul class="menu-list" [ngClass]="{ 'nav-menu-keyboard-hover': openDropdown === HeaderDropdowns.Files }">
                    @if (client && contact && (!client.divisionBasedAccess || contact.hasAccessToAllDivisions || showDataFiles())) {
                      <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Files)" routerLink="/files/data-files" *appHasPermission="'/files/data-files'">
                        <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="data-files-menu">Data Files</a>
                      </li>
                    }
                    <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Files)" routerLink="/files/templates" *appHasPermission="'/files/templates'">
                      <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="templates-menu">Templates</a>
                    </li>
                    <li tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Files)" routerLink="/files/documents" *appHasPermission="'/files/documents'">
                      <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" id="my-documents-menu">My Documents</a>
                    </li>
                    @if (isFileSettingAllowed) {
                      <li *appHasPermission="'/files/file-settings'" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Files)" routerLink="/files/file-settings">
                        <a (click)="triggerGAevent()" (keydown.enter)="triggerGAevent()" tabindex="0" role="button" id="templates-menu">File Settings</a>
                      </li>
                    }
                  </ul>
                </a>
              </li>
              <li class="nav-item" *appHasPermission="'menuReports'">
                <a class="nav-link py-4" tabindex="0" role="button" routerLink="/reports">Reports</a>
              </li>
              <li class="nav-item" *appHasPermission="'menuBilling'">
                <a
                  class="nav-link py-4"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="$event.target.click()"
                  (mouseenter)="$event.target.click()"
                  (mouseleave)="onOpenDropdown()"
                  (click)="onOpenDropdown(HeaderDropdowns.Invoices)"
                  routerLinkActive="active"
                  id="menuTransactions"
                  >Invoices
                  <ul class="menu-list" [ngClass]="{ 'nav-menu-keyboard-hover': openDropdown === HeaderDropdowns.Invoices }">
                    @if (isNetSuite) {
                      <span>
                        <li (click)="openDialog('billing')" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Invoices)">
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" data-cy="account-history"
                            >Account History
                            <img class="ml-2" alt="" src="../../../../assets/img/open-new-tab.svg" />
                          </a>
                        </li>
                        <li (click)="openDialog('invoice')" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Invoices)">
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" data-cy="invoices"
                            >Invoices
                            <img class="ml-2" alt="" src="../../../../assets/img/open-new-tab.svg" />
                          </a>
                        </li>
                        <li (click)="openDialog('payment')" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Invoices)">
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" data-cy="payment"
                            >Payment
                            <img class="ml-2" alt="" src="../../../../assets/img/open-new-tab.svg" />
                          </a>
                        </li>
                        <li (click)="openDialog('creditMemo')" tabindex="0" role="button" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Invoices)">
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" data-cy="credit-memo"
                            >Credit Memos
                            <img class="ml-2" alt="" src="../../../../assets/img/open-new-tab.svg" />
                          </a>
                        </li>
                        <li (click)="openDialog('myAccount')" tabindex="0" role="button" *appHasPermission="'/transactions/pay-my-invoice'" (keyup.enter)="$event.target.click(); onOpenDropdown(HeaderDropdowns.Invoices)">
                          <a (click)="openDropdown = null" (keydown.enter)="openDropdown = null" tabindex="0" role="button" data-cy="my-account"
                            >Pay my Invoice
                            <img class="ml-2" alt="" src="../../../../assets/img/open-new-tab.svg" />
                          </a>
                        </li>
                      </span>
                    }
                  </ul>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>

<div class="alert-list">
  <app-alerts-window #alertsWindow [showWindow]="openDropdown === HeaderDropdowns.Alerts" (closeAlert)="toggleAlerts()" (unreadCount)="onUpdateUnreadCount($event)" role="dialog"></app-alerts-window>
</div>
